hrd.charts.CombinedChart = hrd.charts.AbstractChart.extend({
	init: function(options, dynamicOptions, customChartOptions) {
		//console.log(dynamicOptions);
		this.staticChartOptions = $.extend(true, this._specificChartOptions(), customChartOptions || {});
		this._super(options, dynamicOptions);
	},
	doChart: function(dynamicOptions){
		this._super(dynamicOptions);
//		console.log(dynamicOptions);
//		console.log(this.chartOptions);
	},
	doChartOptions: function(){
		return this.staticChartOptions;
	},
	_adaptsSerieNames: function(staticOptions, dynamicOptions){
		if(dynamicOptions.subCharts){
			var names = {};
			$.each(dynamicOptions.subCharts, (j, sub) => {
				if(sub && sub.data){
					$.each(sub.data.series, (k, serie) => {
						names[serie.serieName] = serie.serieDescription;
					});
				}
			});
			staticOptions.data.names = names;
		}
	},
	_dataToColumns: function(staticOptions, dynamicOptions){
		dynamicOptions.data = {
			series: [],
			types: {}
		};
		$.each(dynamicOptions.subCharts, (j, sub) => {
			if(sub && sub.data){
				dynamicOptions.data.series = dynamicOptions.data.series.concat(sub.data.series)
				$.each(sub.data.series, (k, serie) => {
					dynamicOptions.data.types[serie.serieName] = this.extractType(sub);
				});
			}
		});
		var data = dynamicOptions.data;
		var stacked = dynamicOptions.stacked;
		var columns = [];
		var colors = {};
		var classes = {};
		var axes = {};
		if(data && $.isArray(data.series) && data.series.length > 0){
			// merging for filling all series and avoid empties
			if(this.settings.useXs){
				var xs = {};
				$.each(data.series, function(i, serie){
					var xName = 'x' + i;
					xs[serie.serieName] = xName;
					var x = [];
					var y = [];
					x.push(xName);
					y.push(serie.serieName);
					$.each(serie.items, function(j, item){
						x.push(item.x);
						y.push(item.y);
					})
					columns.push(x);
					columns.push(y);
					if(serie.serieColor){
						colors[serie.serieName] = serie.serieColor;
					}
					if(serie.classes){
						classes[serie.serieName] = serie.classes;
					}
					if(serie.axesType){
						axes[serie.serieName] = serie.axesType;
					}
				});
				staticOptions.data.xs = xs;
			} else {
				// settings for 'X' category axes values, reading all x values from first serie
				var x = ['x'];
				$.each(data.series[0].items, function(i, item){
					x.push(item.x);
				})
				columns.push(x);

				$.each(data.series, function(i, serie){
					var s = [];
					s.push(serie.serieName);
					$.each(serie.items, function(i, item){
						s.push(item.y);
					})
					columns.push(s);
					if(serie.serieColor){
						colors[serie.serieName] = serie.serieColor;
					}
					if(serie.classes){
						classes[serie.serieName] = serie.classes;
					}
					if(serie.axesType){
						axes[serie.serieName] = serie.axesType;
					}
				});
				staticOptions.data.x = 'x';
			}
			if(stacked){
				var groups = [];
				$.each(data.series, function(i, serie){
					if(serie.stackable){
						groups.push(serie.serieName);
					}
				});
				staticOptions.data.groups = [groups]; // is double array
			}
		}
		if(dynamicOptions.labels != undefined){
			if(dynamicOptions.labels.labelFormatter){
				staticOptions.data.labels = {
					format: this.toFormatFunction(dynamicOptions.labels.labelFormatter)
				};
			} else {
				staticOptions.data.labels = true;
			}
		}
		staticOptions.data.colors = colors;
		staticOptions.data.classes = classes;
		staticOptions.data.columns = columns;
		staticOptions.data.axes = axes;
		staticOptions.data.types = dynamicOptions.data.types;
	},
	_adaptSpecificChart: function(staticOptions, dynamicOptions){
	}
});